import { MutationTree } from 'vuex'
import { MapaPeligroState, StoreError } from '@/store/modules/mapa-peligro/types'
import { MapaPeligroApi } from '@/domain/entities/Api'

export const mutations: MutationTree<MapaPeligroState> = {
  MAPA_PELIGRO_FETCHED (state, payload: MapaPeligroApi[]) {
    state.error = { state: false }
    state.mapasPeligro = payload
  },
  MAPA_PELIGRO_ERROR (state, payload: StoreError) {
    state.error = payload
  },
  MAPA_PELIGRO_DELETED (state, payload: MapaPeligroState) {
    state.error = { state: false }
    state.mapasPeligro = []
  }
}
